import React from "react";

const QatarMofaMain = () => {
  return (
    <div className="uaeMofaMainContainer">
      <p>
        When planning to move abroad for employment, education, or family
        settlement, ensuring that your documents are authenticated is a critical
        step in the process. his holds especially true for anyone relocating to
        Qatar. One of the most important procedures in this regard is the
        attestation of documents from the{" "}
        <a href="https://goodwayattestation.com/mofa-attestation-services">
          Ministry of Foreign Affairs (MOFA)
        </a>{" "}
        of Qatar. After your documents have been attested by the country in
        which they were originally issued, they must undergo further
        verification by the MOFA in Qatar to be legally recognized.
      </p>
    </div>
  );
};

export default QatarMofaMain;
